import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const getOrCreateSessionId = () => {
  let sid = sessionStorage.getItem('apdn_sid');
  if (!sid) {
    sid = crypto.randomUUID();
    sessionStorage.setItem('apdn_sid', sid);
  }
  return sid;
};

export const useAnalytics = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    if (location.pathname === lastPath.current) return;
    lastPath.current = location.pathname;

    const payload = {
      sessionId: getOrCreateSessionId(),
      path: location.pathname,
      referrer: document.referrer || null,
      userAgent: navigator.userAgent,
    };

    // Fire and forget — don't block the UI
    fetch('/.netlify/functions/track-pageview', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(() => {}); // silent fail — never crash the site over analytics
  }, [location.pathname]);
};
